module.exports = __webpack_public_path__ + "img/singup2.24153200.jpg";